import { create } from 'zustand';

export const usePresenceStore = create((set) => ({
    onlineUsers: [],
    setOnlineUsers: (users) => set({ onlineUsers: users }),
}));